import { render } from "./OrganicMediaGrid.vue?vue&type=template&id=e001d724&scoped=true"
import script from "./OrganicMediaGrid.vue?vue&type=script&lang=js"
export * from "./OrganicMediaGrid.vue?vue&type=script&lang=js"

import "./OrganicMediaGrid.vue?vue&type=style&index=0&id=e001d724&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e001d724"]])

export default __exports__